module.exports = __webpack_public_path__ + "img/onePieceGarment.7f9f6a67.png";